/**
 * @file 判断设备
 * @author yuanyaojia<yuanyaojia@baijiahulian.com>
 */

/**
 * 判断是移动端还是PC端
 * 如果为true则是移动端，为false就是PC端
 */

export const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);

// 是否是UC浏览器
export const isUCbrowser = /ucbrowser/i.test(navigator.userAgent);

/**
 * 获取访问ua
 */
export const getUA = () => navigator.userAgent;


export const isIOS = /iPhone|iOS|iphone|ipad|ipod/.test(navigator.userAgent);

export const isAndroid = /Android|Linux/.test(navigator.userAgent);

/**
 * 判断safari
 */
export const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
